import React from "react";
import { Loader } from "tabler-icons-react";

/**
 * Composant pour les boutons d'action du formulaire d'édition
 */
const EditEnfantActions = ({ isSubmitting, onCancel }) => {
  return (
    <div className="flex flex-col gap-3 mt-6 mb-8">
      <button
        type="submit"
        className="w-full bg-primary text-white font-bold py-4 px-6 rounded-full flex items-center justify-center gap-2 hover:bg-primary/90 transition-colors disabled:opacity-50"
        disabled={isSubmitting}
      >
        {isSubmitting && <Loader size={20} className="animate-spin" />}
        Enregistrer
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="w-full bg-transparent text-primary font-bold py-3 px-6 rounded-full hover:bg-gray/50 transition-colors"
        disabled={isSubmitting}
      >
        Annuler
      </button>
    </div>
  );
};

export default EditEnfantActions;
